import { parseQuery } from '@calendly/http-tools'

import { Cookies } from 'services/cookies'

const {
  embed_domain: embedDomain,
  embed_type: embedType,
  hide_gdpr_banner: hideGdprBanner
} = parseQuery(window.location.search)


const isEmbedded = Boolean(embedDomain && embedType)
const isHidden = Boolean(hideGdprBanner) // e.g. null -> false
const cookies = new Cookies()
const isDismissed = cookies.getCookie('gdpr_dismissal') === 'true'
const hasOptInCookie = cookies.getCookie('gdpr_trackable') === 'true'

const initialState = {
  isEmbedded,
  isHidden,
  isDismissed,
  isOptedIn: hasOptInCookie
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'GDPR_OPT_IN':
      return {
        ...state,
        isOptedIn: true
      }

    case 'GDPR_DISMISS_CONSENT':
      return {
        ...state,
        isDismissed: true
      }

    default:
      return {
        ...initialState,
        ...state,
      }
  }
}
